export default "/a5b48e0946994335e17e220415b7ad8a9ff4e295/89a905b293692b6c3482c1f38a6975ca.png";